export default __webpack_public_path__ + "static/media/monitor-refresh-icon.7cfaa3c8.svg";